<div class="mt-2" *ngIf="beneficiariesList">
    <h6 class="card-header-label" style="padding-left: 1em;">Lista dei beneficiari</h6>
    <ng-container *ngFor="let beneficiary of beneficiariesList">
        <div class="pt-2 col-7" *ngIf="!beneficiary?.toBeDeleted">
            <app-basic-card>
                <div class="d-flex align-items-center vertical-align-middle justify-content-between">
                    <div class="d-flex align-items-center vertical-align-middle">
                        <mat-icon class="user-icon" aria-hidden="false" aria-label="user-icon" fontIcon="account_circle"></mat-icon>
                        {{ beneficiary.name && beneficiary.surname ? beneficiary.name + ' ' + beneficiary.surname : beneficiary.descBeneficiary }} - {{ getBeneficiaryQuote(beneficiary) }}%
                    </div>
                    <mat-icon [ngClass]="isQuestionnaireCompiled(beneficiary) ? 'filled-questionnaire-icon' : 'requested-questionnaire-icon'"
                      aria-hidden="false"
                      aria-label="assignment_add"
                      fontIcon="assignment_add"
                      [matTooltip]="'Compila questionario'"
                      (click)="openBeneficiaryQuestionnaire(beneficiary)"
                      *ngIf="showQuestionnaireIcon(beneficiary)">
                    </mat-icon>
                    <mat-icon class="modify-icon"
                      aria-hidden="false"
                      aria-label="remove-icon"
                      fontIcon="visibility"
                      [matTooltip]="'Visualizza beneficiario'"
                      (click)="viewBeneficiary(beneficiary)"
                      *ngIf="canModifyBeneficiary(beneficiary)">
                    </mat-icon>
                    <mat-icon class="remove-icon"
                      aria-hidden="false"
                      aria-label="remove-icon"
                      fontIcon="delete"
                      [matTooltip]="'Rimuovi beneficiario'"
                      (click)="removeBeneficiary(beneficiary)"
                      *ngIf="!isReadOnly">
                    </mat-icon>
                </div>
            </app-basic-card>
        </div>
    </ng-container>
</div>
<div class="d-flex flex-column justify-content-start mt-4">
    <div class="card-disclaimer-label" *ngIf="maxQuotas">Attenzione! La somma delle quote supera il 100%</div>
</div>
<div class="mt-4 d-flex">
    <button mat-raised-button class="mx-3" color="primary" (click)="openNewBeneficiaryModal()" [disabled]="isReadOnly || canAddNewBeneficiary">{{'aggiungi beneficiario' | uppercase}}</button>
</div>
